import store from "../store/Provider";
import { UNSET_ADMIN } from "../store/Admin/admin.type";

/** Paths where 401 is an expected credential error, not an expired session. */
export function isAdminLoginRequestUrl(url) {
  if (!url || typeof url !== "string") return false;
  const normalized = url.replace(/^https?:\/\/[^/]+/i, "").toLowerCase();
  return normalized.includes("admin/login");
}

export function redirectToLoginOnUnauthorizedSession(url) {
  if (isAdminLoginRequestUrl(url)) return;
  store.dispatch({ type: UNSET_ADMIN });
  window.location.replace("/login");
}
